import styled from 'styled-components'
import { Icon } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import { get } from 'lodash'
import React from 'react'
import ConversationTime from './ConversationTime'
import { InteractionIcon } from '../elements/Interaction'

const AvatarContainer = styled.div`
  position: relative;
  margin: 0.3em;
  &:last-child {
    margin-right: 1em;
  }
`
const MessageCounter = styled.div`
  border-radius: 10px;
  font-size: ${props => props.size === 'small' ? '0.6em' : '0.8em' };
  width: 20px;
  height: 20px;
  text-align: center;
  position: absolute;
  ${props => props.position === 'top' ? 'top: 15px' : 'bottom: 0px'};
  right: -4px;
  
  background: ${props => props.color};
  color: #fff;
`
const PremiumStarContainer = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  
  font-size: 1.3em;
  color: #fed74d;
  .star-icon {
    margin: 0;
  }
`
const UserImage = styled.img`
  height: 2.5em;
  width: 2.5em;
  border-radius: 50%;
  border: ${props => props.online ? '2px solid #00FF33' : 'none'};
`
const SalesCount = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -42%);
  font-size: 0.5em;
  font-weight: bold;
  color: black;
  z-index: 1000;
`
const Avatar = ({ profileImage, username, messageCount, isPremium, messageBackgroundColor, online = false, numberOfSales = 0}) => {
  return (
    <AvatarContainer>
      <UserImage src={profileImage} alt={username} online={online}/>
      {messageCount > 0 && <MessageCounter  color={messageBackgroundColor} size={messageCount/100 >= 1 ? 'small' : ''} position={!isPremium && 'top'}>{messageCount}</MessageCounter>}
      {isPremium === 1
        &&
        <>
          <PremiumStarContainer>
            {numberOfSales > 0 && <SalesCount>{numberOfSales > 99 ? 99 : numberOfSales}</SalesCount> }
            <Icon className="star-icon" name="star"/>
          </PremiumStarContainer>
        </>}
    </AvatarContainer>
  )
}

const Interaction = observer(({ conversation }) => {
  const { matched, meLiked, otherUserLiked } = conversation.interactions
  return (<InteractionIcon
    matched={matched}
    meLiked={meLiked}
    otherUserLiked={otherUserLiked}
  />)
})

const ConversationContainer = styled.div`
  padding: 0.4em 0.2em 0.2em 0.4em;
  font-size: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  transition: background-color 200ms ease-out;
  
  background: ${({remainingMessages}) =>
    remainingMessages >= 50 && '#E8EEF5' || 
    remainingMessages === 0 && '#E8EEF5' || // ex-premium user with 0 credits
    remainingMessages >= 20 && '#FFF8DC' ||
    remainingMessages > 0 && '#FCD7D7' ||
    '#fff' // everything else color in white
  };
  
  border: ${({isNewAttached}) => 
    isNewAttached && '2px solid #90EE90'
  };
`
const TimerContainer = styled.div`
  margin-right: auto;
`
export const Conversation = observer(({ conversation, style, openConversation = () => {} }) => {
  if (!conversation) {
    return null
  }

  let remainingMessages
  if (conversation.isCreditSite) {
    remainingMessages = conversation.remainingMessages
  } else {
    // no credit site, meaning user is either from subscription site or free -> color white
    remainingMessages = -1
  }
  const isNewAttached = !!conversation.isNewAttached

  return (
    <ConversationContainer key={conversation.conversationUid} onClick={() => openConversation(conversation)}
                           style={style} remainingMessages={remainingMessages} isNewAttached={isNewAttached}>
      <TimerContainer>
        <ConversationTime conversation={conversation}/>
      </TimerContainer>
      <Interaction conversation={conversation}/>
      <Avatar profileImage={get(conversation, 'meProfile.profileImage')}
              username={get(conversation, 'meProfile.username')} messageCount={conversation.meMessageCount}
              messageBackgroundColor="green"/>
      <Avatar profileImage={get(conversation, 'otherUserProfile.profileImage')}
              username={get(conversation, 'otherUserProfile.username')} messageCount={conversation.unreadByMeCount}
              messageBackgroundColor="red" isPremium={conversation.otherUserProfile.isPremium}
              online={get(conversation, 'otherUserActive')}
              numberOfSales={get(conversation, 'salesPerUser')}/>
    </ConversationContainer>
  )
})
